





































import { Component, Prop } from 'vue-property-decorator';
import SaascadaVue from '@/components/Shared/SaascadaVue';
import WalletOverview from '@/components/Accounts/DepositAccounts/Wallets/WalletOverview.vue';
import WalletTransactionsList from '@/components/Accounts/DepositAccounts/Wallets/Transactions/WalletTransactionsList.vue';
import DefaultWalletSettings from '@/components/Accounts/DepositAccounts/Wallets/DefaultWallet/DefaultWalletSettings.vue';
import SecondaryWalletsSettings from '@/components/Accounts/DepositAccounts/Wallets/SecondaryWallets/SecondaryWalletsSettings.vue';
import DefaultWalletValues from '@/components/Accounts/DepositAccounts/Wallets/DefaultWallet/DefaultWalletValues.vue';
import Wallet from "@/models/Accounts/DepositAccounts/Wallets/Wallet";
import DepositAccountSummary from "@/models/Accounts/DepositAccounts/DepositAccountSummary";

@Component({ name: 'WalletSubTabs', components: { WalletOverview, WalletTransactionsList, DefaultWalletSettings, SecondaryWalletsSettings, DefaultWalletValues } })
export default class extends SaascadaVue {

    @Prop({required: true})
    wallet: Wallet;

    @Prop({required: true})
    account: DepositAccountSummary;

    get accountHasValues() {
        return this.wallet.default && this.account.accountValues;
    }

}
